import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "/vercel/path0/fluxos-frontend/components/site-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/vercel/path0/fluxos-frontend/components/site-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/fluxos-frontend/node_modules/next/dist/client/app-dir/link.js");
